async function load() {
    let url = '/browsing_context_suggestions.json';
    let obj = await (await fetch(url)).json();
    if(getCookie('browsing_detector') != 'true' && document.location.host == 'international.trollbeads.com') {
      $('.js-modal-open-lang-modal button').click()
      setCookie('browsing_detector',true,7)
    }
}
load();

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

if(getParameterByName('country_selector') == 'true') {
  $('.js-modal-open-lang-modal button').click()
}

setTimeout(function(){
  var recommendedHtml = ''
  document.querySelectorAll("[data-country='Denmark']").forEach(element => {
      element.setAttribute('style','font-weight:bold;')
      if(recommendedHtml == '') {
          recommendedHtml += '<h3>Based on your location</h3><ul>'
      }
      recommendedHtml += element.outerHTML
  })
  if(recommendedHtml) {
    $('.countries-list').before('<center style="background: #eee;padding: 17px 0 1px 0;">' + recommendedHtml + '</ul><center>')
  }
}, 5000)